module.exports = __webpack_public_path__ + "img/hand-shake.e0cb2a03.svg";